import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { useTeamInvitationListModel } from "features/project-team/ui/project-team-invitation-list/model/useProjectTeamInvitationListModel"

import { ProjectTeamInvitationListOverlayModel } from "../ProjectTeamInvitationListOverlay"

export function useProjectTeamInvitationListOverlayModel(): ProjectTeamInvitationListOverlayModel {
  const { closeOverlay } = useCurrentOverlay()

  const projectTeamInvitationListModel = useTeamInvitationListModel({
    onNavigateToProject: closeOverlay
  })

  return { projectTeamInvitationListModel, onClose: closeOverlay }
}
